type FormatPhoneOptions = {
  showPlusOne?: boolean; // Ensure +1 prefix
  showParentheses?: boolean; // (Optional future use)
  separator?: string; // "-", " ", ".", or ""
};

export function formatPhoneNumber(phone: string, options: FormatPhoneOptions = {}): string {
  const { showPlusOne = false, separator = '' } = options;
  let cleaned = phone.replace(/[^\d+]/g, '');
  let hasPlusOne = cleaned.startsWith('+1');
  if (showPlusOne && !hasPlusOne) {
    cleaned = '+1' + cleaned.replace(/^1/, '');
    hasPlusOne = true;
  }
  const digits = cleaned.replace(/^\+1/, '').replace(/\D/g, '');

  if (digits.length !== 10) return cleaned;

  const area = digits.slice(0, 3);
  const mid = digits.slice(3, 6);
  const last = digits.slice(6);
  const formattedCore = [area, mid, last].join(separator);
  if (showPlusOne || hasPlusOne) {
    return `+1${separator}${formattedCore}`;
  }

  return formattedCore;
}
